export const currentCountrySelector = (entId) => (state) =>
    state.getIn(['ui', 'modules', 'report', 'workspace', entId, 'entity', 'country', 'iso3'])
